import { Col, Row } from 'react-bootstrap';
import { RenderHeading } from 'components/RenderHeading';
import { SectionContainer } from 'components/FormikForm/Section/SectionContainer';
import React from 'react';

interface SectionProps {
    title?: string;
    subtitle?: string | boolean;
    hasLayout?: boolean;
    padding?: boolean;
    children: React.ReactNode;
    className?: string;
}

export const Section: React.FC<SectionProps> = ({
    title,
    subtitle = false,
    hasLayout = false,
    padding = false,
    children,
    className,
}) => {
    return (
        <Row className={className}>
            <Col xs={12}>
                {title && <RenderHeading label={title}/>}
                {subtitle && <p className="mb-3">{subtitle}</p>}
                <Row className={`${padding ? 'section-padding' : ''}`}>
                    <SectionContainer hasLayout={hasLayout}>
                        {children}
                    </SectionContainer>
                </Row>
            </Col>
        </Row>
    );
};
